import React, { forwardRef } from "react";
import { GlobalIcon } from "get-life-storybook-ts";

interface V3FinalCTAProps {
  translate: (key: string) => string;
  onClick: () => void;
  capitalLabel: string;
  priceLabel: string;
  suffix: string;
}

const V3FinalCTA = forwardRef<HTMLDivElement, V3FinalCTAProps>(
  ({ translate, onClick, capitalLabel, priceLabel, suffix }, ref) => {
    return (
      <section className="upsell-v3__finalCta" ref={ref}>
        <div className="upsell-v3__finalCta-glow" aria-hidden="true" />
        <div className="upsell-v3__finalCta-inner">
          <div className="upsell-v3__eyebrow" style={{ color: "rgba(255,255,255,0.85)" }}>
            {translate("newUpsell.v3.finalCta.eyebrow")}
          </div>
          <h2 className="upsell-v3__finalCta-title">
            {translate("newUpsell.v3.hero.sentence.prefix").replace(
              "{capital}",
              capitalLabel
            )}{" "}
            <span className="upsell-v3__finalCta-price">{priceLabel}</span>{" "}
            <span
              className="upsell-v3__finalCta-suffix"
              dangerouslySetInnerHTML={{ __html: suffix }}
            />
          </h2>
          <p className="upsell-v3__finalCta-sub">
            {translate("newUpsell.v3.finalCta.subtitle")}
          </p>
          <button
            type="button"
            className="upsell-v3__finalCta-button"
            onClick={onClick}
          >
            {translate("newUpsell.v3.finalCta.cta")}
            <GlobalIcon iconName="ArrowRightIcon" size="S" color="#423EF4" />
          </button>
          <div className="upsell-v3__finalCta-payment">
            {translate("newUpsell.v3.finalCta.payment")}
          </div>
        </div>
      </section>
    );
  }
);

V3FinalCTA.displayName = "V3FinalCTA";

export default V3FinalCTA;
